import React, { useState, useEffect } from 'react';
import CoreDialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';

function Dialog ({ title, modalOpen, onClose, children,   maxWidth = "sm", fullWidth = true, disableBackdropClose = false }) {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        setOpen(modalOpen)
    }, [modalOpen])

    const handleClose = (event, reason) => {
        if (
            disableBackdropClose &&
            (reason === "backdropClick" || reason === "escapeKeyDown")
        ) {
            return;
        }
        setOpen(false);
        onClose()
    };

    return (
        <>
            <CoreDialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                  maxWidth={maxWidth}
                    fullWidth={fullWidth}

            >
                <DialogTitle id="alert-dialog-title">
                    {title}
                </DialogTitle>
                {children}
            </CoreDialog>
        </>
    );
}

export default Dialog;
